import styles from "./Separator.module.css";

export default function Separator() {
  return (
    <div className={styles.container} aria-hidden="true">
      <span className={`${styles.line} ${styles.left}`} />
      <span className={styles.dot} />
      <span className={`${styles.line} ${styles.right}`} />
    </div>
  );
}
